import { render, staticRenderFns } from "./CustomerPricing.vue?vue&type=template&id=54309476&"
import script from "./CustomerPricing.vue?vue&type=script&lang=js&"
export * from "./CustomerPricing.vue?vue&type=script&lang=js&"
import style0 from "./CustomerPricing.vue?vue&type=style&index=0&id=54309476&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports